export default "__VITE_ASSET__Bb6wY1ms__"